import { PDFViewer } from "@react-pdf/renderer";
import PrintPojo from "./print-pojo.component";

const PDFPojoComponent = (props: any) => {
  return (
    <div>
      <PDFViewer width="1000" height="650" className="app" >
        <PrintPojo data={props.data} />
      </PDFViewer>
    </div>
  );
}

export default PDFPojoComponent;